import React, {useEffect, useState} from "react";
import PexMapLoader from "./PexMapLoader";
import {PexMapBlockCMSProps} from "./types";
import {InputSelectOption} from "../Shared/Components/InputSelect/types";
import {
    IRecyclingStationsResponse,
    RecyclingStationDetails,
    RecyclingStationItem
} from "../Shared/Services/RecyclingStations/interfaces";
import RecyclingStationsService from "../Shared/Services/RecyclingStations/RecyclingStations.service";
import {uniqueId} from "lodash";
import {filterRecyclingStations, formatRecyclingOptions} from "./utils";
import {StatusCode} from "../Shared/Services/Response.types";
import {getLocale} from "@apps/Shared/Utils/Utils";
import {useGetStartPageModelQuery, usePexMapBlockQuery} from "@apps/Shared/GraphQL/generated";


function App(): JSX.Element {
    const hiddenInput = document.querySelector('.js-pex-map');
    const id = Number((hiddenInput as HTMLInputElement).value);
    const locale = getLocale();

    const [pexMapBlockItem, setPexMapBlockItem] = useState<any>(null);
    const [googleMapsApiKey, setGoogleMapsApiKey] = useState<any>(null);
    const [defaultSelectedAlternatives, setDefaultSelectedAlternatives] = useState<string[]>([]);

    const {data: pexMapData} = usePexMapBlockQuery({
        id: id,
        locale: [locale]
    });


    const {data: startPageData} = useGetStartPageModelQuery({
        locale: [locale]
    })

    let cmsprops = {} as PexMapBlockCMSProps;

    useEffect(() => {
        if (pexMapData?.Content?.items?.[0]) {
            const item: any = pexMapData.Content.items[0];
            setPexMapBlockItem(item);
            setDefaultSelectedAlternatives(
                (item.PreSelectedRecyclingAlternatives &&
                    item.PreSelectedRecyclingAlternatives.length > 0 &&
                    item.PreSelectedRecyclingAlternatives.split(',')) ||
                []);
        }
    }, [pexMapData]);

    useEffect(() => {
        if (defaultSelectedAlternatives.length > 0) {
            fetchStations(true);
        }
    }, [defaultSelectedAlternatives]);

    useEffect(() => {
        if (startPageData?.StartPageModel?.items?.[0]) {
            setGoogleMapsApiKey(startPageData.StartPageModel.items[0].MapsApiKey);
        }
    }, [startPageData]);

    const IdPrefix = uniqueId();
    const [stations, setStations] = useState<RecyclingStationItem[]>([]);
    const [stationsFiltered, setStationsFiltered] = useState<
        RecyclingStationItem[]
    >([]);
    const [stationDetails, setStationDetails] = useState<
        RecyclingStationDetails
    >();
    const [loadingStationDetails, setLoadingStationDetails] = useState<boolean>(
        false
    );

    const filterStations = (
        selected: InputSelectOption[],
        stationsToFilter: RecyclingStationItem[]
    ) => {
        const newFiltered = filterRecyclingStations(
            selected,
            stationsToFilter || stations
        );
        setStationsFiltered(newFiltered);
    }

    const fetchStations = (doFilter: boolean) => {
        let response: IRecyclingStationsResponse = {
            stations: [],
        }
        RecyclingStationsService.GetRecyclingStations()
            .then(result => {
                const status = result.status;
                if (status === StatusCode.OK) {
                    response.stations = result.data;
                    setStations(response.stations);
                    if (doFilter) {
                        const defaultSelection = formatRecyclingOptions(defaultSelectedAlternatives);
                        filterStations(defaultSelection, response.stations);
                    } else {
                        setStationsFiltered(response.stations);
                    }
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const onMarkerClick = (station: RecyclingStationItem) => {
        let response: RecyclingStationDetails | undefined = undefined;
        setLoadingStationDetails(true);
        RecyclingStationsService.GetStationDetails(station.id)
            .then(result => {
                const status = result.status;
                if (status === StatusCode.OK) {
                    response = result.data;
                    setStationDetails(response);
                }
                setLoadingStationDetails(false);
            })
            .catch(error => {
                console.log(error)
                setLoadingStationDetails(false);
            });
    }

    if (pexMapBlockItem && googleMapsApiKey) {
        cmsprops = {
            availableRecyclingAlternatives: pexMapBlockItem.AvailableRecyclingAlternatives,
            preSelectedRecyclingAlternatives: pexMapBlockItem.PreSelectedRecyclingAlternatives,
            showSearch: pexMapBlockItem.ShowSearch,
            recycleAlternativesLabel: pexMapBlockItem.RecycleAlternativesLabel,
            recycleAlternativesDialogContent: pexMapBlockItem.RecycleAlternativesDialogContent,
        };

        const modalLinkText = cmsprops.recycleAlternativesLabel;
        const recyclingOptions =
            (cmsprops.availableRecyclingAlternatives &&
                cmsprops.availableRecyclingAlternatives.length > 0 &&
                cmsprops.availableRecyclingAlternatives.split(',')) ||
            [];
        const showSearch = !!cmsprops.showSearch;
        const recycleDialogContent = cmsprops.recycleAlternativesDialogContent;

        return (
            <PexMapLoader recyclingOptions={recyclingOptions}
                          modalLinkText={modalLinkText}
                          showSearch={showSearch}
                          defaultSelectedAlternatives={defaultSelectedAlternatives}
                          stations={stations}
                          stationsFiltered={stationsFiltered}
                          onMarkerClick={onMarkerClick}
                          stationDetails={stationDetails}
                          recycleDialogContent={recycleDialogContent}
                          filterStations={filterStations}
                          loadingStationDetails={loadingStationDetails}
                          idPrefix={IdPrefix}
                          googleMapsApiKey={googleMapsApiKey}/>
        );
    } else {
        return <></>;
    }
}

export default App;